// removed by extract-text-webpack-plugin
module.exports = {"title":"Header_title--25Y5l","eventName":"Header_eventName--6on4m"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/Header/Header.scss
// module id = 2475
// module chunks = 11